import { render } from "./HelpModal.vue?vue&type=template&id=2aa6b609&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2aa6b609"

export default script